import PageHero from "../components/PageHero";
import CtaBanner from "../components/CtaBanner";
import QuoteForm from "../components/QuoteForm";
import { Reveal } from "../components/Reveal";
import { lawnImages } from "../data/site";

const features = [
  "Weekly & bi-weekly lawn mowing",
  "Planting & garden design",
  "Trimming, edging & clean-up",
  "Fertilization & soil health",
  "Spring & fall property clean-ups",
  "Seasonal bed maintenance",
];

const LawnMaintenance = () => (
  <div data-testid="lawn-maintenance-page">
    <PageHero
      overline="Lawn Maintenance"
      title="A pristine lawn, every week of the season."
      subtitle="Lawn care, planting and garden design that keeps your property healthy, green and well kept."
      image={lawnImages[0]}
    />

    <section className="py-24 md:py-32 bg-bone">
      <div className="container-fl grid md:grid-cols-12 gap-12 md:gap-20 items-center">
        <Reveal className="md:col-span-6">
          <p className="overline mb-5">Year-Round Care</p>
          <h2 className="text-4xl md:text-5xl leading-tight mb-6">Consistent, dependable lawn care.</h2>
          <p className="text-lg text-moss leading-relaxed mb-8">
            From routine mowing to full garden design, our team keeps your outdoor space looking its best. We handle the details — planting, edging, clean-ups and soil health — so your property stays green, tidy and inviting all season long.
          </p>
          <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-4">
            {features.map((f) => (
              <li key={f} className="flex items-start gap-3 text-ink">
                <span className="text-clay mt-1">—</span>
                <span className="font-medium">{f}</span>
              </li>
            ))}
          </ul>
        </Reveal>
        <Reveal delay={0.15} className="md:col-span-6">
          <img src={lawnImages[1]} alt="Freshly mowed striped lawn" className="w-full aspect-[4/5] object-cover" />
        </Reveal>
      </div>
    </section>

    <section className="pb-24 md:pb-32 bg-bone">
      <div className="container-fl grid grid-cols-1 md:grid-cols-2 gap-4">
        <Reveal><img src={lawnImages[2]} alt="Manicured lawn by the water" className="w-full aspect-[16/10] object-cover" /></Reveal>
        <Reveal delay={0.1}><img src={lawnImages[3]} alt="Crisp lawn edging along driveway" className="w-full aspect-[16/10] object-cover" /></Reveal>
      </div>
    </section>

    <section className="py-24 md:py-28 bg-sand">
      <div className="container-fl grid md:grid-cols-12 gap-14">
        <Reveal className="md:col-span-5">
          <p className="overline mb-5">Get Started</p>
          <h2 className="text-4xl md:text-5xl leading-tight">Keep your lawn looking fresh.</h2>
        </Reveal>
        <Reveal delay={0.1} className="md:col-span-7 bg-white p-8 md:p-12 border border-line">
          <QuoteForm defaultService="Lawn Maintenance" />
        </Reveal>
      </div>
    </section>

    <CtaBanner />
  </div>
);

export default LawnMaintenance;
